module.exports = __webpack_public_path__ + "static/media/pic_winie2_03.09436371.png";